import React from 'react'
import { urlFor } from '../client'

const ArticleImage = ({ value, node, ...props }) => {
    if (!value && !node) return <div className="p-3 rounded bg-slate-100 text-slate-700">Invalid image</div>
    value = value || node
    if (!value || !value?.img) return <div className="p-3 rounded bg-slate-100 text-slate-700">Invalid image</div>
    if (value.img._upload) return <div className="p-3 rounded bg-slate-100 text-slate-700">Loading...</div>
    const num = Object.keys(urlFor(value.img).options.source).length;
    if (num === 1) return <div className="p-3 rounded bg-slate-100 text-slate-700">Invalid image</div>
    try {
        return (
            <>
                {
                    value.img
                        ?
                        <img style={{
                            maxWidth: "700px",
                            maxHeight: "700px",
                            width: "99%",
                            margin: "20px auto"
                        }} src={urlFor(value.img)} alt="the pic" />
                        :
                        <div className="p-3 rounded bg-slate-100 text-slate-700">No image</div>
                }
            </>
        )
    } catch (e) {
        console.log("ERROR: ", e);
        return <div>Something went wrong. Please try again.</div>
    }
}

export default ArticleImage